import { c as _c } from "react/compiler-runtime";
import { filterMetricValues } from '@/modules/finances/lib/breakdown-table-utils';
import type { MetricValues } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
import { getKeyMetric } from '../table-header/cell-semi-annually';
import { LinkCell } from './link-cell';
interface TableCellProps {
  metrics: string[];
  value: MetricValues;
  href: string;
  isSummaryRow?: boolean;
}
function TableCell(t0) {
  const $ = _c(21);
  const {
    metrics,
    value,
    href,
    isSummaryRow
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== href || $[1] !== isSummaryRow || $[2] !== metrics || $[3] !== value) {
    const filteredData = filterMetricValues(value, metrics);
    t5 = "border-border relative border-r px-2 py-4 text-center text-xs xl:px-5";
    T0 = LinkCell;
    t3 = href;
    t4 = isSummaryRow;
    t1 = "flex flex-row items-center justify-center gap-0";
    t2 = metrics.map((metric, index) => {
      const key = getKeyMetric(metric) as keyof MetricValues;
      const numValue = filteredData[key] ?? 0;
      return <span key={index} className="text-foreground min-w-[77.5px] text-center xl:min-w-[83.5px] 2xl:min-w-[80px]">{usLocalizedNumber(numValue, 0)}</span>;
    });
    $[0] = href;
    $[1] = isSummaryRow;
    $[2] = metrics;
    $[3] = value;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== T0 || $[14] !== t3 || $[15] !== t4 || $[16] !== t6) {
    t7 = <T0 href={t3} isSummaryRow={t4}>{t6}</T0>;
    $[13] = T0;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <td className={t5}>{t7}</td>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
export { TableCell };